// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"49897ac4","455":"c86ed1ea","548":"00cecbb7","977":"768deec6"}[chunkId] + ".chunk.js";
};